import {Adapter} from "./adapter";
import {nextFrame} from "../Utils";

export default class VideoAdapter extends Adapter {
    setup() {
        this._currentIndex = 0;
        this.dialog.items.forEach(item => {
            const $video = $(`<video class="popup__video" controls></video>`);
            $video.attr('data-src', item.src);

            this._elements.push({
                $el: $video,
                src: item.src,
                title: item.title || '',
                ready: () => new Promise((resolve, reject) => {
                    const video = $video[0];
                    if (!$video.attr('data-src')) {
                        resolve(video);
                        return;
                    }

                    $video.attr('src', item.src);
                    $video.on('loadeddata', () => {
                        $video.attr('width', video.videoWidth);
                        $video.attr('height', video.videoHeight);
                        resolve(video);
                    });
                    $video.on('error', () => {
                        console.log('error', video);
                        reject(video);
                    });
                    $video.attr('src', $video.attr('data-src'));
                    $video.removeAttr('data-src');
                }),
            });
        });
    }
}
